import { render } from "./FormulaSelector.vue?vue&type=template&id=3b01c8b8&ts=true"
import script from "./FormulaSelector.vue?vue&type=script&lang=ts"
export * from "./FormulaSelector.vue?vue&type=script&lang=ts"

import "./FormulaSelector.vue?vue&type=style&index=0&id=3b01c8b8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTooltip,QMenu,QSelect,QField});
